import React from "react";
import ForgotPassword from "../components/ForgotPassword";

function PasswordReset() {
    return (
      <>
        <ForgotPassword />
      </>
    );
  };
  
export default PasswordReset;